import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ToastConnectedProps } from '../../../components/toast/types';

const initialState: {
  toasts: ToastConnectedProps[];
} = {
  toasts: [],
};

const NL_TOAST_KEY = 'TOAST_BET_ABOVE_MINIMUM';

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    createToast: (state, action: PayloadAction<string>) => {
      const identicalToast = state.toasts.find((toast) => toast.message === action.payload);

      // If the toast is already in the list, remove it and add the incoming one, for it to appear on top and override previous one of same type
      if (identicalToast)
        toastSlice.caseReducers.removeToast(state, { payload: identicalToast.timeStamp, type: 'toast-remove' });

      state.toasts = [...state.toasts, { message: action.payload, timeStamp: Date.now() }];

      if (state.toasts.length > 3) {
        // toast with 'TOAST_BET_ABOVE_MINIMUM' message should always stay on top NL Jurisdiction
        const toastToRemove = state.toasts.find((toast) => toast.message !== NL_TOAST_KEY);
        if (!toastToRemove) return;
        toastSlice.caseReducers.removeToast(state, { payload: toastToRemove.timeStamp, type: 'toast-remove' });
      }
    },
    removeToast: (state, action: PayloadAction<number>) => {
      state.toasts = state.toasts.filter((toast) => toast.timeStamp !== action.payload);
    },
    removeToastByMessage: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter((toast) => toast.message !== action.payload);
    },
    // TODO: make sure there is no actual need to do it via timestamp and go with the message approach, remove this then
    removeNLToast: (state) => {
      state.toasts = state.toasts.filter((toast) => toast.message !== NL_TOAST_KEY);
    },
  },
});

export const toastActions = toastSlice.actions;
